import { Controller } from "@hotwired/stimulus"

// Orders the shop cards inside each plan-state group (active, downgraded, cancelled); the groups keep their order.
export default class extends Controller {
  static targets = ["group", "card", "label"]

  connect() {
    const current = this.element.querySelector("[data-sort-key].text-ps-orange")
    if (current) this.apply(current.dataset.sortKey)
    this.refresh()
  }

  sort(event) {
    event.preventDefault()
    const button = event.currentTarget
    if (this.hasLabelTarget) this.labelTarget.textContent = button.textContent.trim()

    this.element.querySelectorAll("[data-sort-key]").forEach((el) => {
      const active = el === button
      el.classList.toggle("text-ps-orange", active)
      el.classList.toggle("font-semibold", active)
      el.classList.toggle("text-gray-700", !active)
    })

    this.apply(button.dataset.sortKey)
  }

  apply(key) {
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" })
    const byName = (a, b) => collator.compare(a.dataset.name, b.dataset.name)
    const byUpdated = (a, b) => Number(a.dataset.updated) - Number(b.dataset.updated)
    const comparators = {
      name_asc: byName,
      name_desc: (a, b) => byName(b, a),
      type: (a, b) => collator.compare(a.dataset.type, b.dataset.type) || byName(a, b),
      updated_desc: (a, b) => byUpdated(b, a),
      updated_asc: byUpdated
    }
    const compare = comparators[key] || byName

    this.groupTargets.forEach((group) => {
      const cards = this.cardTargets.filter((card) => card.parentElement === group)
      cards.sort(compare).forEach((card) => group.appendChild(card))
    })
  }

  // A group whose every card the search hides takes its notice with it.
  refresh() {
    this.groupTargets.forEach((group) => {
      const cards = this.cardTargets.filter((card) => card.parentElement === group)
      group.classList.toggle("hidden", cards.length > 0 && cards.every((card) => card.classList.contains("hidden")))
    })
  }
}
